import { render, staticRenderFns } from "./ObiContainer.vue?vue&type=template&id=3da85635&scoped=true&"
import script from "./ObiContainer.vue?vue&type=script&lang=js&"
export * from "./ObiContainer.vue?vue&type=script&lang=js&"
import style0 from "./ObiContainer.vue?vue&type=style&index=0&id=3da85635&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da85635",
  null
  
)

export default component.exports